<template>
  <b-modal
    modal-class="create-listing-modal"
    size="lg"
    :visible="visible"
    :no-fade="true"
    :hide-footer="true"
    title="Create a Listing"
    @hide="hide()"
    @shown="onShown()"
  >
    <p class="text-center py-5">
      What do you need to do?
    </p>
    <div class="card-deck card-deck-lg">
      <a href="#" class="card text-decoration-none text-body mb-3 mb-lg-0">
        <span class="card-body text-center">
          <span class="h1 text-center d-block mb-2">
            <i class="fa fa-home"></i>
          </span>
          <span class="d-block">Create Public Listing</span>
          <small class="d-block">
            Let's create a public listing in your MLS.
            <span class="text-underline">Get Started</span>
          </small>
        </span>
      </a>
      <a href="#" class="card text-decoration-none text-body mb-3 mb-lg-0">
        <span class="card-body text-center">
          <span class="h1 text-center d-block mb-2">
            <i class="fa fa-lock"></i>
          </span>
          <span class="d-block">Create Private Listing</span>
          <small class="d-block">
            Let's create your listing in accessRedwood.
            <span class="text-underline">Get Started</span>
          </small>
        </span>
      </a>
      <a href="#" class="card text-decoration-none text-body">
        <span class="card-body text-center">
          <span class="h1 text-center d-block mb-2">
            <i class="fa fa-calendar"></i>
          </span>
          <span class="d-block">Prepare Pre-Marketing</span>
          <small class="d-block">
            Let's create your listing in accessRedwood.
            <span class="text-underline">Get Started</span>
          </small>
        </span>
      </a>
    </div>
  </b-modal>
</template>

<style lang="scss">
.create-listing-modal {
  .modal-body {
    background-color: #ECF0F1;
  }

  @media screen and (max-width: 768px) {
    .modal-content {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: 0;
    }

    .modal-body {
      position: fixed;
      top: 81px;
      height: calc(100vh - 81px);
      left: 0;
      right: 0;
      bottom: 0;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
    }
  }
}
</style>

<script>
import $ from 'jquery'

const $window = $(window)

export default {
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    $window.on('createListing.requested', (e) => {
      this.show()
    })
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
      return true
    },
    onShown() {
      //
    }
  }
}
</script>
